import React from 'react';

/**
 * Custom markdown component overrides for react-markdown.
 * Borrowed from prosci_portal's markdownCustomRenderers.tsx
 */

// LLM-sourced markdown can contain arbitrary link schemes (javascript:,
// data:, etc.) — only allow http(s)/mailto/tel or scheme-less relative URLs.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const ALLOWED_SCHEMES = /^(https?|mailto|tel):/i;

const isSafeHref = (href: string) => {
  const trimmed = href.trim();
  return !HAS_SCHEME.test(trimmed) || ALLOWED_SCHEMES.test(trimmed);
};

const markdownRenderers = {
  a: ({ href, children }: { href?: string; children?: React.ReactNode }) => {
    if (href && !isSafeHref(href)) return <span>{children}</span>;
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
  td: ({ children }: { children?: React.ReactNode }) => {
    if (!children) return <td></td>;
    const processedContent: React.ReactNode[] = [];
    let textAccumulator = '';

    const processAccumulatedText = () => {
      if (textAccumulator) {
        if (textAccumulator.includes('•')) {
          const listItems = textAccumulator
            .split('•')
            .map((item) => item.trim())
            .filter((item) => item);
          processedContent.push(
            <ul>
              {listItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>,
          );
        } else {
          processedContent.push(textAccumulator);
        }
        textAccumulator = '';
      }
    };

    React.Children.toArray(children).forEach((child) => {
      if (typeof child === 'string') {
        if (child.includes('<br>')) return;
        textAccumulator += child;
      } else {
        processAccumulatedText();
        processedContent.push(child);
      }
    });
    processAccumulatedText();
    return (
      <td>
        {processedContent.length === 1 ? (
          processedContent[0]
        ) : (
          <React.Fragment>{processedContent}</React.Fragment>
        )}
      </td>
    );
  },
  table: ({
    children,
    ...props
  }: { children?: React.ReactNode } & React.TableHTMLAttributes<HTMLTableElement>) => {
    return (
      <div className="table-wrapper overflow-x-auto">
        <table {...props}>{children}</table>
      </div>
    );
  },
};

export default markdownRenderers;
